import { contactFormParametersGeneration } from './contactFormParametersGeneration'
import { contactSaveParametersGeneration } from './IT/contactSaveParametersGeneration'
import type { ContactSubscriptionData } from './contactSubscriptionData'

type GenerateContactParametersParams = {
  contactData: ContactSubscriptionData
  id: string | number
  country: string
  action: string
  doorToDoorPartnerChecklistCheckedTitles: Record<string, boolean>
  doorToDoorPartnerLeadSource: string
}

type ContactParametersGenerator = (params: Omit<GenerateContactParametersParams, 'doorToDoorPartnerChecklistCheckedTitles' | 'doorToDoorPartnerLeadSource'>) => URLSearchParams

const parametersGeneratorByCountry: Record<string, ContactParametersGenerator> = {
  it: contactSaveParametersGeneration,
}

export function generateContactParameters({
  contactData,
  id,
  country,
  action,
  doorToDoorPartnerChecklistCheckedTitles,
  doorToDoorPartnerLeadSource,
}: GenerateContactParametersParams): URLSearchParams {
  const generator = parametersGeneratorByCountry[country]

  if (generator) {
    return generator({ contactData, id, country, action })
  }

  return contactFormParametersGeneration({ contactData, id, country, action, doorToDoorPartnerChecklistCheckedTitles, doorToDoorPartnerLeadSource })
}
